import { z } from 'zod';
/**
 * 고객 aisight 서버가 생성하는 challenge.
 * base64(JSON) — 라이선스 사이트의 활성화 페이지에 붙여넣는다.
 */
export const ChallengePayloadSchema = z.object({
    /** 고객 aisight 의 HW fingerprint (sha256). */
    hwid: z
        .string()
        .length(64)
        .regex(/^[0-9a-f]+$/),
    /** aisight 버전 (예: "2026.5.1"). */
    appVersion: z.string(),
    /** 활성화 시도 시각 (ISO 8601). server clock 기준. */
    timestamp: z.string().datetime(),
    /** replay 방지 nonce (base64, 16바이트 random). */
    nonce: z.string(),
    /** 고객이 입력한 license_key. server 가 검증. */
    licenseKey: z.string(),
});
/** 라이선스 사이트 POST /api/activate 요청. */
export const ActivateRequestSchema = z.object({
    /** base64 인코딩된 ChallengePayload. */
    challenge: z.string().min(1),
});
/**
 * JWT (EdDSA) 페이로드. 발급된 token 의 평문 내용.
 * server 가 ed25519 비밀키로 서명, aisight 가 hardcoded 공개키로 검증.
 */
export const ActivationTokenPayloadSchema = z.object({
    /** JWT subject = license_key. */
    sub: z.string(),
    /** 활성화된 deployment 의 hwid (challenge 의 hwid 그대로). */
    hwid: z.string().length(64),
    /** Activation ID (UUID). admin 이 추적/revoke 시 사용. */
    jti: z.string().uuid(),
    /** features allowlist. */
    features: z.array(z.string()),
    /** Unix epoch seconds. JWT 표준 클레임. */
    iat: z.number().int(),
    /** Unix epoch seconds. null/큰 값 = 사실상 영구. */
    exp: z.number().int().nullable().optional(),
    /** issuer. 본사 도메인 또는 식별자. */
    iss: z.string(),
    /** 활성화 시점의 aisight 버전 (참조용). */
    appVersion: z.string().optional(),
    /** 최대 동시 사용자 수. 미지정 = 무제한 (기존 라이선스 호환). */
    maxUsers: z.number().int().positive().optional(),
    /**
     * 등급 키 (예: 'aisightCore'). **표시 전용** — 기능 강제는 features[] 가 단독으로 한다.
     * 미지정 = 레거시 발급분. 제품은 이 경우 aisightCore 로 떨어뜨린다.
     */
    level: z.string().optional(),
    /** 등급 표시명 (예: 'aisight core'). 제품이 모르는 신규 등급도 사람이 읽을 수 있게 같이 싣는다. */
    levelLabel: z.string().optional(),
});
//# sourceMappingURL=activation.js.map